<template>
	<div>
		<form-sidebar>
			<v-form>
				<accounting-filter
					column
					:companies="subsidiaries"
					:subsidiary-id="params.subsidiaryId"
					:disabled-years="!params.subsidiaryId"
					:year-accountant-id="params.yearAccountantId"
					:years="yearsBySubsidiary"
					@filter="filter($event)"
				/>
				<v-layout wrap mt-2>
					<v-flex xs12>
						<BaseSelect
							:disabled="!params.yearAccountantId"
							:height="38"
							v-model="planId"
							item-text="description"
							item-value="id"
							:items="plans"
							:return-object="false"
							label="Plan de Cuentas"
							@input="setPlan($event, 'planId')"
						/>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						@cancel-button-clicked="closeModal"
						@accept-button-clicked="submitForm"
						:is-loading="disabled"
					></modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import accountingFilter from '@/components/accounting-plans/accounting-filter';

const PAGE_ACCOUNTING_PLAN_LIST = 'accounting-plans';

function created() {
	this.loadSubsidiaries();
}

function closeModal() {
	this.goTo(PAGE_ACCOUNTING_PLAN_LIST, { params: { subsidiaryId: this.params.subsidiaryId } });
}

function disabled() {
	return !this.planId || this.loading;
}

function filter({ value, model }) {
	this.params[model] = value.id;
	this.planId = null;
	if (model === 'subsidiaryId') {
		this.params.yearAccountantId = null;
		this.loadYears(this.params.subsidiaryId);
	} else if (model === 'yearAccountantId') {
		this.loadPlans();
	}
}

async function loadPlans() {
	const params = {
		subsidiaryId: this.params.subsidiaryId,
		yearAccountantId: this.params.yearAccountantId,
	};
	({ data: this.plans } = await this.$http.get('com-accounting-plan', { params }));
}

async function loadSubsidiaries() {
	({ data: this.subsidiaries } = await this.$http.get('subsidiary', { params: {} }));
	if (this.subsidiaryId) {
		this.params.subsidiaryId = this.subsidiaryId;
		this.loadYears(this.subsidiaryId);
	}
}

async function loadYears(id) {
	const params = { subsidiaryId: id };
	({ data: this.yearsBySubsidiary } = await this.$http.get('com-year-accountant', { params }));
	if (this.yearAccountantId) {
		this.params.yearAccountantId = this.yearAccountantId;
		this.loadPlans();
	}
}

function setPlan(value, model) {
	this[model] = value;
}

async function submitForm() {
	this.loading = true;
	try {
		await this.$http.patch(`com-accounting-plan/${this.planId}/active`);
		this.showNotification('El plan ha sido activado correctamente.');
		this.closeModal();
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		this.loading = false;
	}
}

function data() {
	return {
		loading: false,
		planId: null,
		plans: [],
		subsidiaries: [],
		yearsBySubsidiary: [],
	};
}

export default {
	name: 'acc-plan-active-form',
	components: {
		accountingFilter,
		BaseSelect: () => import('@/components/shared/inputs/base-select'),
	},
	computed: {
		disabled,
	},
	created,
	data,
	methods: {
		closeModal,
		filter,
		loadPlans,
		loadSubsidiaries,
		loadYears,
		setPlan,
		submitForm,
	},
	props: {
		subsidiaryId: [Number, String],
		yearAccountantId: [Number, String],
	},
};
</script>



// WEBPACK FOOTER //
// src/components/accounting-plans/acc-plan-active-form.vue